import React from 'react';

/**
 * ScreenShareIcon - holito brand-tier icon (2px stroke, 24 grid, the notch where applicable).
 * Geometry from the brand guide (docs/DESIGN.md section 08 / Iconography).
 */
export const ScreenShareIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M10 4 H12 M20 12 V14 A6 6 0 0 1 14 20 H10 A6 6 0 0 1 4 14 V10 A6 6 0 0 1 10 4" />
    <path d="M12 16 V10" />
    <path d="M9 12 L12 9 L15 12" />
  </svg>
);
